<div class="emd-trend-wrap">
  <!-- Legend sits above the plot: click toggles a series, hover previews it. -->
  <div class="emd-trend-legend" *ngIf="legend.length">
    <button
      type="button"
      class="emd-legend-btn"
      *ngFor="let entry of legend"
      [class.is-hidden]="hidden.has(entry.key)"
      [attr.aria-pressed]="!hidden.has(entry.key)"
      (click)="toggleSeries(entry.key)"
      (mouseenter)="emphasise(entry.key)"
      (mouseleave)="emphasise(null)"
      (focus)="emphasise(entry.key)"
      (blur)="emphasise(null)"
    >
      <span
        class="emd-legend-mark"
        [class.emd-legend-mark--line]="entry.type === 'line'"
        [style.background]="entry.color"
      ></span>
      {{ entry.label }}
    </button>
  </div>

  <div
    class="emd-trend-plot"
    tabindex="0"
    role="img"
    [attr.aria-label]="ariaLabel"
    (keydown)="onKeydown($event)"
    (blur)="onBlur()"
  >
    <div #chart class="emd-trend-svg"></div>

    <emd-chart-states
      [loading]="false"
      [empty]="!hasData"
      message="There is no data for this time period"
    ></emd-chart-states>

    <emd-chart-tooltip
      [visible]="tooltipVisible"
      [title]="tooltipTitle"
      [rows]="tooltipRows"
      [x]="tooltipX"
      [y]="tooltipY"
      [hostWidth]="width"
      [hostHeight]="height"
    ></emd-chart-tooltip>
  </div>
</div>
